/** Strip Arabic diacritics and Quranic marks used in Persian text search. */
const DIACRITICS_RE = /[\u064B-\u065F\u0670\u06D6-\u06ED]/g
/** ZWNJ, ZWJ, bidi marks, BOM — ignored when matching. */
const INVISIBLE_RE = /[\u200C-\u200D\u200E-\u200F\uFEFF]/g

const PERSIAN_DIGITS = '۰۱۲۳۴۵۶۷۸۹'
const ARABIC_DIGITS = '٠١٢٣٤٥٦٧٨٩'

/**
 * Normalize text for Persian-friendly substring search (case/digit/letter variants).
 * @param {unknown} input
 * @returns {string}
 */
export function normalizePersianSearchText (input) {
  if (input == null) return ''
  let s = String(input)
  s = s.replace(DIACRITICS_RE, '')
  s = s.replace(INVISIBLE_RE, '')
  s = s.replace(/\u064A/g, '\u06CC') // ي → ی
  s = s.replace(/\u0643/g, '\u06A9') // ك → ک
  s = s.normalize('NFKC').toLowerCase()
  s = s.replace(/[۰-۹]/g, (c) => String(PERSIAN_DIGITS.indexOf(c)))
  s = s.replace(/[٠-٩]/g, (c) => String(ARABIC_DIGITS.indexOf(c)))
  s = s.replace(/\s+/g, ' ').trim()
  return s
}

/**
 * @param {unknown} haystack
 * @param {unknown} needle
 * @returns {boolean}
 */
export function persianSearchIncludes (haystack, needle) {
  const q = normalizePersianSearchText(needle)
  if (!q) return true
  return normalizePersianSearchText(haystack).includes(q)
}
